import React, { useState } from 'react';
import LoadAll from 'schema/container/LoadAll';
import get from 'lodash.get';
import config from 'config';

import { Navigation, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import 'swiper/swiper.scss';
import 'swiper/modules/navigation/navigation.scss';
import 'swiper/modules/pagination/pagination.scss';
import 'swiper/modules/scrollbar/scrollbar.scss';
import 'swiper/modules/autoplay/autoplay.scss';
import Skeleton from 'components/Skeleton/UsefulLink';
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";


function Component() {

  const { t } = useTranslation();
  const [swiper, setSwiper] = useState(null);
  const { system: { language }} = useSelector(state => state);

  return (
    <div className={"py-5 border-top border-1"}>
      <div className="container">
        <div className={"d-flex align-items-center justify-content-between mb-4"}>
          <div className={"d-flex align-items-center text-uppercase fs-26 fw-500"}>
            <span className={"bg-primary rounded-circle p-1 me-2"} />
            {t("text.useful")}
          </div>
        </div>

        <LoadAll
          url={"/resources"}
          name={"usefulLinks"}
          params={{
            extra: {
              lang: language
            }
          }}
        >
          {({ isFetched, data=[],}) => {
            return <>

              <div className="links-group">
                <Swiper
                  modules={[Navigation, Autoplay]}
                  spaceBetween={10}
                  slidesPerView={2}
                  onSwiper={setSwiper}
                  autoplay={{
                    delay: 3000
                  }}
                  className={"pb-1"}
                  observeParents={isFetched}
                  breakpoints={{
                    575: {
                      slidesPerView: 2
                    },
                    768: {
                      slidesPerView: 3
                    },
                    991: {
                      slidesPerView: 4
                    },
                    1200: {
                      slidesPerView: 5
                    }
                  }}
                >
                  {
                    isFetched && data?.map((item, key) => (
                      <SwiperSlide key={key} className={"h-auto"}>
                        <a
                          style={{ minHeight: 150}}
                          href={get(item, "url")}
                          rel={"noopener noreferrer"}
                          target={"_blank"}
                          className={"p-3 text-center h-100 d-flex flex-column align-items-center justify-content-center bg-white overflow-hidden rounded-3 text-custom border border-primary-hover shadow-sm"}
                        >
                          <img className={"mw-100 mb-2 w-78"} src={config.FILE_ROOT + get(item, "imageUrl")} alt=""/>
                          <div className={"fs-18 lh-sm fw-500 text-primary"}>{ get(item, "name")}</div>
                        </a>
                      </SwiperSlide>
                    ))
                  }
                  {
                    !isFetched
                      ? [1,2,3,4,5].map((key) => (
                        <SwiperSlide className={"h-auto"} key={key}>
                          <Skeleton />
                        </SwiperSlide>
                      ))
                      : null
                  }
                </Swiper>
              </div>
              {
                isFetched && data.length
                ? <div className={"pt-3"}>
                    <button className={"btn btn-sm btn-outline-primary me-2"} onClick={() => swiper && swiper.slidePrev()}>
                      <i className={"fas fa-angle-left"}/>
                    </button>
                    <button className={"btn btn-sm btn-outline-primary me-2"} onClick={() => swiper && swiper.slideNext()}>
                      <i className={"fas fa-angle-right"}/>
                    </button>
                  </div>
                : null
              }
            </>
          }}
        </LoadAll>
      </div>
    </div>
  );
}

export default Component;